import {ActionTree} from "vuex";

const actions: ActionTree<IssueTrackerState, RootState> = {

};

export default actions;
